module.exports = __webpack_public_path__ + "static/img/68a8d81981add855aa26fc0b7767280f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ps_banner.png
// module id = 9YDU
// module chunks = 1